'use strict';

import Vue from 'vue'
import Vuex from 'vuex'

const fields = [
  "userId", "name", "username", "password",
  "deptId", "deptName", "roleId", "roleName",
  "funcIds", "deptRoles", "roleParams", "menus"
];
const LSKEY = "__vuex_state";

export default {
  getStore() {
    // console.log("in get Store.");

    // 从 sessionStorage 加载数据
    const last = JSON.parse(window.sessionStorage.getItem(LSKEY) || "{}");

    return new Vuex.Store({
      state: last,

      mutations: {
        login(state, payload) {
          //console.log("in VueX login");

          fields.forEach(p => Vue.set(state, p, payload[p]));

          // funcIds 和 roleParams将在 "/" 加载时获取
          //state.funcIds = [];
          Vue.set(state, "funcIds", []);
          // state.roleParams = [];
          Vue.set(state, "roleParams", []);

          window.sessionStorage.setItem(LSKEY, JSON.stringify(state));
        },
        logout(state) {
          //console.log("in VueX logout");

          fields.forEach(p => Vue.set(state, p, null));

          // funcIds 和 roleParams将在 "/" 加载时获取
          //state.funcIds = [];
          Vue.set(state, "funcIds", []);
          // state.roleParams = [];
          Vue.set(state, "roleParams", []);

          window.sessionStorage.removeItem(LSKEY);
        },
        changeRole(state, payload) {
          // console.log("in VueX changeRole");

          //state.deptId = payload.deptId;
          Vue.set(state, "deptId", payload.deptId);

          // state.deptName = payload.deptName;
          Vue.set(state, "deptName", payload.deptName);

          // state.roleId = payload.roleId;
          Vue.set(state, "roleId", payload.roleId);

          // state.roleName = payload.roleName;
          Vue.set(state, "roleName", payload.roleName);


          // funcIds 和 roleParams将在 "/" 加载时获取
          //state.funcIds = [];
          Vue.set(state, "funcIds", []);
          // state.roleParams = [];
          Vue.set(state, "roleParams", []);

          window.sessionStorage.setItem(LSKEY, JSON.stringify(state));
        },
        funcsAndParams(state, payload) {
          // console.log("in VueX funcIds");

          //state.funcIds = payload.funcIds;
          Vue.set(state, "funcIds", payload.funcIds);

          //state.roleParams = payload.roleParams;
          Vue.set(state, "roleParams", payload.roleParams);

          window.sessionStorage.setItem(LSKEY, JSON.stringify(state));
        },
        menus(state, payload) {
          //state.roleParams = payload.roleParams;
          Vue.set(state, "menus", ["/", "/403", ...payload]);

          window.sessionStorage.setItem(LSKEY, JSON.stringify(state));
        }
      },

      getters: {
        authenticated: state => state.userId != null,
        userId: state => state.userId,
        name: state => state.name,
        username: state => state.username,
        password: state => state.password,
        deptId: state => state.deptId,
        deptName: state => state.deptName,
        roleId: state => state.roleId,
        roleName: state => state.roleName,
        funcIds: state => state.funcIds,
        roleParams: state => state.roleParams,
        deptRoles: state => state.deptRoles,
        deptAccessCode: state => ((state.deptRoles || []).find(v => v.deptId === state.deptId) || {}).deptAccessCode,
        menus: state => state.menus || null
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js